<template>
  <v-app>
    <header-comp></header-comp>
    <hero-section-comp id="inicio"></hero-section-comp>
    <servicios-comp id="servicios"></servicios-comp>
    <GaleriaComp id="galeria"></GaleriaComp>
    <nosotros-comp id="nosotros"></nosotros-comp>
    <contacto-comp id="contacto"></contacto-comp>
    <footer-comp></footer-comp>
  </v-app>
</template>

<script>
import HeaderComp from "@/components/HeaderComp.vue";
import HeroSectionComp from "@/components/HeroSectionComp.vue";
import ServiciosComp from "@/components/ServiciosComp.vue";
import GaleriaComp from "@/components/GaleriaComp.vue";
import NosotrosComp from "@/components/NosotrosComp.vue";
import ContactoComp from "@/components/ContactoComp.vue";
import FooterComp from "@/components/FooterComp.vue";

export default {
  name: 'App',

  components: {
    HeaderComp,
    HeroSectionComp,
    ServiciosComp,
    GaleriaComp,
    NosotrosComp,
    ContactoComp,
    FooterComp,
  },

  data: () => ({
    //
  }),
}
</script>
